<div (click)="opened ? closePanel() : openPanel()"
  class="header"
  [class.active]="opened">
  <ng-content select="[panel-header]"></ng-content>
  <button class="icon-button"
    [@rotate]="opened ? 'active' : 'inactive'">
    <svg-icon icon="icon-caret-up"></svg-icon>
  </button>
</div>
<div class="luna-accordion-content-wrapper"
  [@height]="opened ? 'opened' : 'closed'"
  [@opacity]="opened ? 'visible' : 'hidden'"
  (@height.start)="animationInProgress = !animationInProgress"
  (@height.done)="animationInProgress = !animationInProgress">
  @if (opened || animationInProgress) {
    <div class="luna-accordion-content">
      <ng-content>
      </ng-content>
    </div>
  }
</div>
